import React from "react";

const ASingleLambdaTestLive = ({ name, count }) => {
    return (
        <>
            <div className="if-output-container">
                <div className="a-single-test">
                    <div className="left-of-test">
                        <div className="ready-words">
                            <div className="count borders" style={{ color: "var(--accent-one)" }}>{count >= 0 ? count : 0 }</div>
                        </div>
                        {"passing: "}
                        {name ? name : "<Missing Name>"}
                    </div>
                </div>
            </div>
        </>
    );
}

export default ASingleLambdaTestLive;